import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './composingUploadConfirmationModalMessages';

function getMessage(error) {
  switch (true) {
    case /Invalid extension - /g.test(error):
      return messages.invalidExtension;
    case /Integration data not found/g.test(error):
      return messages.errorIntergrationDataNotFound;
    case /Permission denied/g.test(error):
      return messages.errorNoPermission;
    case /Error while uploading the file to the server/g.test(error):
      return messages.errorUploadingFile;
    case /Error while integrating file/g.test(error):
      return messages.errorIntegratingFile;
    case /Error while uploading the file. Try again uploading the file to the student/g.test(error):
      return messages.errorUploadingFileToStudent;
    default:
      return messages.errorGeneric;
  }
}

function ComposingUploadConfirmationModal({
  isOpen,
  singularFile,
  onClose,
  intl,
  onBack,
  onContinue,
  ...props
}) {
  let SuccessError = false;
  if (!props.error && props.errorCount > 0) {
    SuccessError = true;
  }

  const message = getMessage(props.error);
  const subtitleMessage = props.amount > 1 ? messages.pluralSubtitle : messages.singularSubtitle;
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon={props.error.length > 0 ? 'ti-thumb-down' : 'ti-thumb-up'}
      title={intl.formatMessage(messages.title)}
      subtitle={
        props.error.length > 0
          ? intl.formatMessage(message)
          : SuccessError
          ? intl.formatMessage(messages.successError)
          : intl.formatMessage(subtitleMessage, { amount: props.amount })
      }
      buttons={[
        {
          label: intl.formatMessage(messages.close),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

ComposingUploadConfirmationModal.defaultProps = {
  amount: 1,
};

export default injectIntl(ComposingUploadConfirmationModal);
